import { Button } from "@mantine/core";
import { useState } from "react";
import {
  BasicConfirmationModal,
  BasicConfirmationModalIcon
} from "../../../../../BuildingBlocks/Layout/Modals/BasicConfirmationModal/BasicConfirmationModal";
import { useTodos } from "../../../../hooks/useTodos";
import type { Mode } from "../../../../Todos.types";

interface GenerateProformaDocumentsButtonProps {
  disabled?: boolean;
  mode: Mode;
  todoId: number;
  variantId: number;
}

function GenerateProformaDocumentsButton({
  disabled,
  mode,
  todoId,
  variantId
}: GenerateProformaDocumentsButtonProps) {
  const [modalIsOpen, setModalIsOpen] = useState(false);
  const toggleModal = () => setModalIsOpen(!modalIsOpen);

  const { generateProformaDocuments, isGeneratingProforma } = useTodos({
    mode,
    variantId
  });

  function handleConfirm() {
    setModalIsOpen(false);
    generateProformaDocuments(todoId);
  }

  return (
    <>
      <Button
        color="primary"
        disabled={disabled}
        loading={isGeneratingProforma}
        variant="outline"
        onClick={toggleModal}
      >
        Pro-Forma-Meldung erstellen
      </Button>
      <BasicConfirmationModal
        confirmationButtonColor="primary"
        confirmationButtonText="Bestätigen"
        icon={BasicConfirmationModalIcon.Success}
        opened={modalIsOpen}
        title="Pro-Forma-Meldeunterlagen erstellen"
        toggleModal={toggleModal}
        onCancel={toggleModal}
        onConfirm={handleConfirm}
      >
        <p>
          Es liegen noch nicht für alle Liegenschaften Ihres Unternehmens
          ausreichend Daten vor. Damit Sie trotzdem bereits Meldungen für alle
          Ihre Liegenschaften einreichen können, erstellt opti.node für Sie
          folgende Meldeunterlagen:
        </p>
        <ul>
          <li>
            Für Liegenschaften mit vollständigen und plausiblen Daten werden die
            vorhandenen Werte in der Berechnung berücksichtigt und gültige
            Dokumentationen erzeugt.
          </li>
          <li>
            Für Liegenschaften mit unvollständigen oder unplausiblen Daten
            werden Proforma-Werte verwendet und Sie erhalten
            Proforma-Unterlagen.
          </li>
        </ul>
        <p>
          Sobald vollständige und plausible Messdaten vorliegen, können Sie die
          finalen Meldeunterlagen erzeugen und nachreichen.
        </p>
      </BasicConfirmationModal>
    </>
  );
}

export { GenerateProformaDocumentsButton };
